import {
  createDocumentFormValues,
  createDocumentFormInitialValues,
} from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";
import shortid from "shortid";
export default function CreateDocumentForm(
  state = createDocumentFormValues,
  action
) {
  const { type, payload, documentIndex, field, documentId, moveToStep } =
    action;
  switch (type) {
    //Next Step
    case types.DOCUMENT_GOTO_NEXT_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) + 1,
      };
    //Previous Step
    case types.DOCUMENT_GOTO_PREVIOUS_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) - 1,
      };
    case types.SET_AND_RESET_ADDITIONAL_DOCUMENTS:
      const { step1: step1data3 } = state;
      return {
        ...state,
        step1: {
          ...step1data3,
          additionalDocuments: payload
            ? [
                {
                  documentId: shortid.generate(),
                  documentName: "",
                  description: "",
                  isRequired: false,
                },
              ]
            : [],
        },
      };

    //Documents CRUD
    //Upload Documents
    case types.SET_STEP_2_UPLOAD_DOCUMENTS:
      const {
        step2,
        step2: { allDocuments = [] },
      } = state;
      payload.forEach((documentURL, index) => {
        allDocuments.push({
          documentURL: documentURL,
          elements: [],
        });
      });
      return {
        ...state,
        step2: {
          ...step2,
          allDocuments,
        },
      };
    //Update Document
    case types.SET_STEP_2_UPDATE_DOCUMENT:
      const {
        step2: step2Data4 = {},
        step2: { allDocuments: uploadedDocuments3 = [] },
      } = state;
      uploadedDocuments3[documentIndex].documentURL = payload;
      return {
        ...state,
        step2: {
          ...step2Data4,
          allDocuments: uploadedDocuments3,
        },
      };
    //INSERT Document
    case types.STEP_2_INSERT_DOCUMENT_BETWEEN_PAGES:
      const {
        step2: step2Data5 = {},
        step2: { allDocuments: uploadedDocuments4 = [] },
      } = state;
      const newIndex = parseInt(documentIndex) + 1;
      const newDocumentData = {
        documentURL: payload,
        elements: [],
      };
      uploadedDocuments4.splice(newIndex, 0, newDocumentData);
      return {
        ...state,
        step2: {
          ...step2Data5,
          allDocuments: uploadedDocuments4,
        },
      };
    //Remove Document
    case types.STEP_2_REMOVE_DOCUMENT:
      const {
        step2: step2Data3 = {},
        step2: { allDocuments: uploadedDocuments2 = [] },
      } = state;
      const newDocuments = uploadedDocuments2.filter(
        (record, index) => parseInt(index) !== parseInt(payload)
      );
      return {
        ...state,
        step2: {
          ...step2Data3,
          allDocuments: newDocuments,
        },
      };

    //Elemets
    //Update Documents Array
    case types.STEP_2_UPDATE_DOCUMENTS_ARRAY:
      const { step2: step2Data = {} } = state;
      return {
        ...state,
        step2: {
          ...step2Data,
          allDocuments: payload,
        },
      };

    //Step1
    //Add Required Document
    case types.STEP_1_ADD_REQUIRED_DOCUMENT:
      const {
        step1,
        step1: { additionalDocuments = [] },
      } = state;
      additionalDocuments.push({
        documentId: shortid.generate(),
        documentName: "",
        description: "",
        isRequired: false,
      });
      return {
        ...state,
        step1: {
          ...step1,
          additionalDocuments,
        },
      };
    //Remove Required Document
    case types.STEP_1_REMOVE_REQUIRED_DOCUMENT:
      const {
        step1: step1Data,
        step1: { additionalDocuments: previousDocuments = [] },
      } = state;
      const filteredDocuments = previousDocuments.filter(
        (document, index) => document.documentId !== documentId
      );
      return {
        ...state,
        step1: {
          ...step1Data,
          additionalDocuments: filteredDocuments,
        },
      };
    //Change Field Values
    case types.STEP_1_REQUIRED_DOCUMENT_FIELD_VALUES:
      const {
        step1: step1Data2,
        step1: { additionalDocuments: reqDocuments = [] },
      } = state;
      reqDocuments.find((document) => document.documentId === documentId)[
        field
      ] = payload;
      return {
        ...state,
        step1: {
          ...step1Data2,
          additionalDocuments: reqDocuments,
        },
      };
    case types.STEP_ONE_CREATE_COMPLETE:
      const { currentStep } = state;
      return {
        ...state,
        agencyServiceId: payload,
        currentStep: parseInt(currentStep) + 1,
      };

    //Set Form As Editable
    case types.SET_DOCUMENT_FORM_AS_EDITABLE:
      const {
        agencyServiceId = "",
        requiredDocuments = "",
        templatePlaceHolderValue = "",
        serviceAmount = "",
        serviceDescription = "",
        serviceDomainURL = "",
        serviceName = "",
        paymentType = "",
        documentType = "",
        locationCodeId = "",
      } = payload;
      const { moveToStep } = action;

      const additionalDocumentsData = JSON.parse(requiredDocuments || "[]");
      let cleaned = templatePlaceHolderValue
        ? templatePlaceHolderValue.replace(/\u0019/g, "'")
        : "[]";
      const placeholders = JSON.parse(cleaned || "[]");
      return {
        ...state,
        currentStep: moveToStep,
        agencyServiceId: parseInt(agencyServiceId),
        step1: {
          formInitialValues: {
            serviceAmount,
            serviceDescription,
            serviceDomainURL,
            serviceName,
            paymentType,
            documentType,
            locationCodeId,
          },
          additionalDocuments: additionalDocumentsData,
        },
        step2: {
          allDocuments: placeholders,
        },
      };
    case types.RESET_DOCUMENT_BUILD_FORM:
      return {
        ...state,
        ...createDocumentFormInitialValues,
      };
    case types.GOTO_SELECTED_STEP:
      return {
        ...state,
        currentStep: payload,
      };
    default:
      return state;
  }
}
